module.exports = __webpack_public_path__ + "static/img/1.2811119.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/1.png
// module id = r9gO
// module chunks = 0